import React from 'react';
import c from 'classnames';
import prettyBytes from 'pretty-bytes';
import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

export interface DownloadProps {
  source: string;
  title: string;
  description?: string;
  filesize?: number;
  filename?: string;
  materialIconName: string;
  target?: HTMLAnchorElement['target'];
  className?: string;
  mime?: string;
}

const Download: React.FC<DownloadProps> = ({
  source,
  title,
  description = null,
  filesize = null,
  filename = '',
  materialIconName,
  mime = '',
  target = '_self',
  className,
}) => {
  const classes = c('Download', className);
  const [, mimeSubType] = mime.split('/');
  const extension = mimeSubType || filename.match(/\w+$/);

  return (
    <a className={classes} target={target} href={source} rel="noreferrer">
      <div className="Download__content">
        <span className="Download__title">{title}</span>
        {description && (
          <div className="Download__description">{description}</div>
        )}
      </div>
      <div className="Download__attributes">
        {extension && (
          <span className="Download__extension">{extension[0]}</span>
        )}
        {extension && filesize && <>&nbsp;</>}
        {filesize && (
          <span className="Download__filesize">({prettyBytes(filesize)})</span>
        )}
      </div>
      <div className="Download__icon">
        <Icon name={materialIconName} flair="outlined" />
      </div>
    </a>
  );
};

export default Download;
